<td class="label">{{ valueProperty.name }}</td>
<td class="value"
    *ngIf="updateOrRemove(sectionChange)"
    [innerHTML]="valueFormat(sectionChange.itemFrom[valueProperty.key])">
</td>
<td class="value"
    *ngIf="updateOrAdd(sectionChange)"
    [innerHTML]="valueFormat(sectionChange.itemTo[valueProperty.key])">
</td>